import { DialogDescription } from '@radix-ui/react-dialog';
import { useQuery } from '@tanstack/react-query';
import { FormattedMessage } from 'react-intl';

import { Loader } from '@/components/global/Loader';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import type { Project } from '@/lib/queries/project';
import { userQueries } from '@/lib/queries/user';

import { InviteExistingUserDialog } from './InviteExistingUserDialog';
import { SignUpAndInviteUserDialog } from './SignUpAndInviteUserDialog';

interface Props {
  closeDialog: () => void;
  email: string;
  mainProject: Project;
}

export const InviteUserDialog = ({
  email,
  mainProject,
  closeDialog,
}: Props): JSX.Element => {
  const { data, isPending, isError } = useQuery(userQueries.exists(email));

  return (
    <Dialog open={true} onOpenChange={closeDialog}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>
            <FormattedMessage id="configuration.projectManagement.inviteUserDialog.title" />
          </DialogTitle>
        </DialogHeader>
        {isPending ? (
          <DialogDescription>
            <Loader />
          </DialogDescription>
        ) : isError ? (
          <DialogDescription>
            <p>
              <FormattedMessage id="configuration.projectManagement.inviteUserDialog.error" />
            </p>
          </DialogDescription>
        ) : data.exists ? (
          <InviteExistingUserDialog
            email={email}
            mainProject={mainProject}
            closeDialog={closeDialog}
          />
        ) : (
          <SignUpAndInviteUserDialog
            email={email}
            mainProject={mainProject}
            closeDialog={closeDialog}
          />
        )}
      </DialogContent>
    </Dialog>
  );
};
